
import {Dictionary} from '../models/dictionary.model';
import {IBaseType} from './ibase-type.enum';

export interface IDocumentRequirementType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class DocumentRequirementType implements IDocumentRequirementType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns SystemRequired DocumentRequirementType
	**/
    public get SystemRequired(): IDocumentRequirementType {
        return this.FromId(1);
    }
    /**
		Returns CSRRequired DocumentRequirementType
	**/
    public get CSRRequired(): IDocumentRequirementType {
        return this.FromId(2);
    }
    /**
		Returns Optional DocumentRequirementType
	**/
    public get Optional(): IDocumentRequirementType {
        return this.FromId(3);
    }
    /**
    Returns Correspondence DocumentRequirementType
    **/
    public get Correspondence(): IDocumentRequirementType {
        return this.FromId(4);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'SystemRequired', displayValue: 'System Required', description: 'System Required', sortOrder: 999, active: true });
        this._dictionary.add('2', { id: 2, value: 'CSRRequired', displayValue: 'CSR Required', description: 'CSR Required', sortOrder: 999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Optional', displayValue: 'Optional', description: 'Optional', sortOrder: 999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Correspondence', displayValue: 'Correspondence', description: 'Correspondence', sortOrder: 999, active: true});
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IDocumentRequirementType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IDocumentRequirementType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IDocumentRequirementType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IDocumentRequirementType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): IDocumentRequirementType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
